import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const HybridCell = (props) => {
    const {column, record, onDoubleClick} = props;
    return (
        <td
            data-id={column.entityContext ? column.id : record.id}
            data-entity-key={column.entityContext || record.entityKey}
            className={classnames("entity-context", {
                "align-center": column.align === "center",
            })}
            onDoubleClick={onDoubleClick}
            width={column.width}
        >
            <div className="form-item">
                {column.content(record)}
            </div>
        </td>
    );
};

HybridCell.propTypes = {
    record: PropTypes.object,
    column: PropTypes.shape({
        label: PropTypes.any,
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        align: PropTypes.string,
    }),
    onDoubleClick: PropTypes.func,
};

export default HybridCell;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/RecordGrid/HybridCell.js